<template>
  <div>
    <!-- 搜索 -->
    <div class="w11">
      <Row>
        <Col>
          <Input
            type="text"
            style="width: 240px; margin-right: 10px"
            v-model="enquirysearch.odd"
            placeholder="单号"
          />
        </Col>
        <Col>
          <Select
            clearable
            v-model="enquirysearch.state"
            style="width: 160px; margin-right: 10px"
            placeholder="状态"
          >
            <Option v-for="item in statelist" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </Col>
        <Col>
          <Input
            style="width: 160px; margin-right: 10px"
            type="text"
            v-model="enquirysearch.code"
            placeholder="配件编码/配件名称"
          />
        </Col>
        <Col>
          <Select
            clearable
            style="width: 160px"
            v-model="enquirysearch.inquirer"
            placeholder="报价人"
          >
            <Option v-for="item in cityList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </Col>
        <Col>
          <Button
            @click="
              pager.current = 1
              enquiryss()
            "
            class="bt ml30"
            style="background-color: rgb(73, 135, 242); color: #fff"
            >搜索</Button
          >
        </Col>
      </Row>
    </div>
    <div class="pagefy" v-show="dataList.length > 0">
      <Page
        :total="pager.total"
        :current="pager.current"
        :page-size="pager.size"
        :page-size-opts="[30]"
        style="padding: 0"
        size="small"
        show-total
        show-sizer
        @on-change="changeCurrentbj"
        @on-page-size-change="changeSizebj"
      />
    </div>
    <!-- 表格 -->
    <!-- 表头 -->
    <Row class="tableHeader">
      <Col span="3">单号</Col>
      <Col span="1">状态</Col>
      <Col style="width: 200px">询价信息</Col>
      <Col style="width: 200px">商品信息</Col>
      <Col span="2">发货地</Col>
      <Col span="1">询价数量</Col>
      <Col style="width: 150px">报价信息</Col>
      <Col style="width: 88px">单价</Col>
      <Col span="2">金额</Col>

      <Col style="width: 110px">操作</Col>
    </Row>
    <div class="table">
      <transition-group
        name="more"
        v-bind:css="false"
        v-on:before-enter="beforeEnter"
        v-on:enter="enter"
      >
        <div
          class="tableCenter"
          v-for="(item, index) in dataList"
          :key="item.id"
        >
          <Row>
            <Col span="3" style="font-size: 12px; font-weight: 700">
              {{ item.id }}</Col
            >
            <Col span="1" style="font-size: 12px">
              <span
                style="font-size: 12px; color: #ff5e00"
                v-if="item.status === 1"
                >{{ item.statusCode }}</span
              >
              <span
                style="font-size: 12px; color: #47c460"
                v-if="item.status === 2"
                >{{ item.statusCode }}</span
              >
              <span
                style="font-size: 12px; color: #9d9d9d"
                v-if="item.status === 3 || item.status === 4"
                >{{ item.statusCode }}</span
              >
            </Col>
            <Col style="width: 200px; font-size: 12px">
              <div>
                <!-- 这期隐藏 -->
                <!-- <div @click="xjskip(item)">{{ item.enquiryTname }}</div> -->
                <div>{{ item.enquiryTname }}</div>
                <div>{{ item.enquirySname }}</div>
                <div>{{ item.createTime }}</div>
              </div>
            </Col>
            <Col
              style="
                width: 200px;
                text-align: left;
                justify-content: flex-start;
                font-size: 12px;
              "
            >
              <div class="w22">
                <div class="original">
                  <div v-show="item.qualityTypeId" class="partType">
                    {{ item.qualityTypeName }}
                  </div>
                  <!-- <Tooltip
                    :content="
                      item.carBrandName +
                        item.direction +
                        item.stdNameJp +
                        item.oeCode
                    "
                    placement="bottom"
                    style="max-width: 280px"
                  >
                    <div @click="skipxq(item)" class="original-name">
                      {{ item.carBrandName }}{{ item.direction
                      }}{{ item.stdNameJp }}{{ item.oeCode }}
                    </div>
                  </Tooltip> -->
                  <Tooltip
                    :content="item.partComplexName"
                    placement="bottom"
                    max-width="380"
                  >
                    <div @click="skipxq(item)" class="original-name">
                      {{ item.partComplexName }}
                    </div>
                  </Tooltip>
                </div>
                <div class="pledge" style="font-size: 12px">
                  <ul style="font-size: 12px">
                    <li v-show="item.genuineGuarantee">
                      <span class="iconfont icon-a-lujing153"></span>
                      <!-- <span style="font-size: 12px">正品保证</span> -->
                    </li>

                    <li v-show="item.technicalSupport">
                      <span class="iconfont icon-a-ziyuan4"></span>
                      <!-- <span style="font-size: 12px">技术支持</span> -->
                    </li>

                    <li v-show="item.warrantyService">
                      <span class="iconfont icon-a-ziyuan5"></span>
                      <!-- <span style="font-size: 12px">保修服务</span> -->
                    </li>

                    <li v-show="item.returnPromise">
                      <span class="iconfont icon-a-ziyuan21"></span>
                      <!-- <span style="font-size: 12px">退换货承诺</span> -->
                    </li>
                  </ul>
                </div>
                <div class="oe-p" @mouseleave="closeRelevance(index)">
                  OE号：
                  <span
                    class="oe-w1"
                    @mouseenter="getRelevance(item.partId, index, item)"
                    v-if="item.oeCodeList"
                  >
                    {{ item.oeCodeList[0] }}
                    <i
                      v-if="item.oeCodeList && item.oeCodeList.length > 1"
                      class="ivu-icon ivu-icon-ios-arrow-down"
                    ></i>
                  </span>
                  <div
                    class="relevance"
                    :tabIndex="1"
                    v-if="item.oeCodeList && item.oeCodeList.length > 1"
                  >
                    <div
                      class="relevanceBox"
                      :class="item.isShow ? 'show' : ''"
                    >
                      <p v-for="i in item.oeCodeList.slice(1)" :key="i">
                        {{ i }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col span="2">
              <span style="font-size: 12px"
                >{{ item.shipCity }}{{ item.shipStore }}</span
              >
            </Col>
            <Col span="1" style="font-size: 12px">{{ item.enquiryNum }}</Col>
            <Col style="width: 150px; font-size: 12px">
              <div>
                <div>{{ item.offerTname }}</div>
                <div>{{ item.offerSname }}{{ item.remark ? "：" + item.remark : ""}}</div>
                <div>{{ item.makeOfferTime }}</div>
              </div>
            </Col>
            <Col style="width: 88px">
              <div
                style="font-size: 14px; color: red"
                class="bold"
                v-if="item.offerPrice"
              >
                ￥{{ item.offerPrice }}
              </div>
              <div v-else style="color: red">--</div>
            </Col>
            <Col span="2">
              <span
                style="font-size: 14px; color: red"
                class="bold"
                v-if="item.totalMoney"
                >￥{{ item.totalMoney }}</span
              >
              <span v-else style="color: red">--</span>
            </Col>
            <Col span="2" style="flex-direction: column">
              <div>
                <span
                  style="font-size: 15px; color: #ff7700; margin-right: 5px"
                  class="iconfont icon-a-lujing156 mr5"
                ></span>
                <span style="font-size: 13px; line-height: 28px">{{
                  item.timer ? item.timer : '00小时00分'
                }}</span>
              </div>
              <div>
                <Button
                  v-show="item.status == 1"
                  class="purchase"
                  style="border: nonen"
                  @click="quote(item)"
                  >报价</Button
                >
                <Button
                  v-show="item.status == 2"
                  class="cxpurchase"
                  style="border: nonen"
                  @click="quote(item)"
                  >重新报价</Button
                >
                <Button
                  v-show="item.status == 3 || item.status == 4"
                  class="grayness"
                  style="border: nonen"
                  disabled
                  >重新报价</Button
                >
              </div>
            </Col>
          </Row>
        </div>
      </transition-group>
      <!-- 询价为空 -->
      <div class="emptyData" v-show="dataList.length == 0">
        <div class="min">
          <span
            style="font-size: 14px; padding: 0 9px 0 5px"
            class="iconfont icon-gantanhao-xianxingyuankuang"
          ></span>
          <span style="font-size: 14px">抱歉！没找到你想要的数据~!</span>
        </div>
      </div>
      <div class="pagefy" v-show="dataList.length > 0">
        <Page
          :total="pager.total"
          :current="pager.current"
          :page-size="pager.size"
          :page-size-opts="[30]"
          size="small"
          show-total
          show-sizer
          @on-change="changeCurrentbj"
          @on-page-size-change="changeSizebj"
        />
      </div>
      <!-- 加载中 -->
      <div class="demo-spin-container" v-if="spinShow">
        <Spin fix></Spin>
      </div>
    </div>
    <!-- 立即询价弹框 -->
    <Modal
      v-model="quotetk"
      title="请确认询价信息:"
      footer-hide
      :mask-closable="false"
      class-name="vertical-center-modal"
      width="380px"
    >
      <div slot="header" style="background-color: #f0f0f0">
        <div class="fz18">请确认报价信息：</div>
      </div>
      <div class="flexj">
        <div class="a" style="width: 80px">买家&nbsp;：</div>
        <div style="width: 200px; display: inline-block" class="dis a">
          {{ quotedata.enquiryTname }}
        </div>
      </div>
      <div class="flexj mt20 a">
        <div class="a flexj" style="width: 70px">询价商品：</div>
        <div style="margin-left: 10px; display: inline-block; width: 200px">
          <div class="mb5">
            <span class="partypexj">{{ quotedata.qualityTypeName }}</span>
            <span class="a"
              >{{ quotedata.carBrandName }}{{ quotedata.stdNameJp
              }}{{ quotedata.oeCode }}</span
            >
          </div>
          <div class="xishop">
            <li
              v-if="quotedata.genuineGuarantee"
              style="width: 90px; display: inline-block; margin-right: 10px"
            >
              <span class="iconfont icon-a-lujing153 b"></span>
              <span style="font-size: 13px" class="a">正品保证</span>
            </li>
            <li
              v-if="quotedata.technicalSupport"
              style="width: 90px; display: inline-block; margin-right: 10px"
            >
              <span class="iconfont icon-a-ziyuan4 b"></span>
              <span style="font-size: 13px" class="a">技术支持</span>
            </li>
            <br />
            <li
              v-if="quotedata.warrantyService"
              style="width: 90px; display: inline-block; margin-right: 10px"
            >
              <span class="iconfont icon-a-ziyuan5 b"></span>
              <span style="font-size: 13px" class="a">保修服务</span>
            </li>
            <li
              v-if="quotedata.returnPromise"
              style="width: 90px; display: inline-block; margin-right: 10px"
            >
              <span class="iconfont icon-a-ziyuan21 b"></span>
              <span style="font-size: 13px" class="a">退换货承诺</span>
            </li>
          </div>
        </div>
      </div>
      <div class="mt20">
        <span
          class="a"
          style="
            width: 80px;
            height: 30px;
            line-height: 30px;
            display: inline-block;
          "
          >发货地&nbsp;:</span
        >
        <span class="a"
          >{{ quotedata.shipCity }}{{ quotedata.shipStore }}
        </span>
      </div>
      <div class="mt20">
        <span
          class="a"
          style="
            width: 80px;
            height: 30px;
            line-height: 30px;
            display: inline-block;
          "
          >询价数量&nbsp;:</span
        >
        <span class="a">{{ quotedata.enquiryNum }}</span>
      </div>
      <div class="mt20">
        <span
            class="a"
            style="
            width: 80px;
            height: 30px;
            line-height: 30px;
            display: inline-block;
          "
        >库存 ：</span>
        <RadioGroup v-model="button1" type="button" button-style="solid" @on-change="stockRadioChange">
          <Radio label="有货"></Radio>
          <Radio label="无货"></Radio>
        </RadioGroup>
      </div>
      <div class="mt20">
        <span
          class="a"
          style="
            width: 80px;
            height: 30px;
            line-height: 30px;
            display: inline-block;
          "
          >单价&nbsp;:</span
        >
        <Input
          size="small"
          v-model="quotedata.offerPrice"
          :disabled="quotedata.noStock === 1"
          style="width: 160px"
        />
      </div>
      <div v-if="pricets">
        <span style="margin-left: 80px"></span>
        <span class="error">最多只能输入两位小数的数字！</span>
      </div>
      <div class="mt20">
        <span
          class="a"
          style="
            width: 78px;
            height: 30px;
            line-height: 30px;
            display: inline-block;
          "
          >金额&nbsp;:</span
        >
        <span style="color: red; font-weight: 700">{{
            quotedata.noStock === 0 ?
          '￥' +
          parseFloat(quotedata.enquiryNum * quotedata.offerPrice || 0).toFixed(2) : "--"
        }}</span>
      </div>
      <div class="mt20">
        <span
            class="a"
            style="
            width: 80px;
            height: 30px;
            line-height: 30px;
            display: inline-block;
          "
        >备注&nbsp;:</span
        >
        <Input
            size="small"
            v-model="quotedata.remark"
            style="width: 160px"
        />
      </div>
      <div class="flexjz mt20">
        <Button
          :loading="quotedata.load"
          @click="enquiryqd(quotedata)"
          class="bt10 footButton"
          style="background-color: #377cf1; color: #fff; margin-right: 10px"
          >确定</Button
        >
        <Button
          @click="enquiryqx(quotedata)"
          class="bt10 footButton"
          style="color: #377cf1; border: 1px solid #377cf1"
          >取消</Button
        >
        <!-- <div class="bt10 footButton"  style="color:#377CF1;border:1px solid #377CF1">确定</div> -->
      </div>
    </Modal>
  </div>
</template>

<script>
import {
  getinquireman,
  getquotelist,
  getquotexx
} from '@/api/askoffer/askquote'
export default {
  data() {
    return {
      value: '', // 单价,
      quotetk: false, // 报价弹框
      quotedata: {}, // 报价信息
      pricets: false, // 单价提示
      spinShow: false, // 加载
      statelist: [
        {
          id: '1',
          name: '等待报价'
        },
        {
          id: '2',
          name: '报价完成'
        },
        {
          id: '3',
          name: '已过期'
        }
      ], //状态列表
      enquirysearch: {
        odd: '', // 单号
        state: '', //状态
        code: '', //编码
        inquirer: '' // 询价人
      }, // 询价搜索
      cityList: [], // 询价人
      dataList: [
        {
          id: '', // 单号
          status: '', // 状态
          enquiryTname: '', // 询价店铺
          enquirySname: '', // 询价名字
          createTime: '', // 询价时间
          qualityTypeId: '', // 询价原厂件
          carBrandName: '', //品牌
          direction: '', //方向
          stdNameJp: '', // 标准名称
          oeCode: '', // 编码
          genuineGuarantee: '', // 正品保障
          technicalSupport: '', // 技术支持
          warrantyService: '', // 保修服务
          returnPromise: '', //退换货承诺
          enquiryNum: '', // 询价数量
          offerTname: '', // 报价信息店铺
          offerSname: '', //报价人
          makeOfferTime: '', //报价时间
          offerPrice: '', // 单价
          totalMoney: '', // 金额
          endTime: '' //有效期
        }
      ],
      // 分页
      pager: {
        current: 1,
        total: 0,
        size: 30
      },
      tenantId: JSON.parse(localStorage.getItem('userdetails_tenantInfo'))
        .tenantId,
      timerinit: [], // 时间指示器
      button1:'有货'
    }
  },
  created() {},
  methods: {

    stockRadioChange(){
      if(this.button1 === '有货'){
        this.quotedata.noStock = 0
      }else{
        this.quotedata.noStock = 1
        delete this.quotedata.offerPrice
      }
    },
    
    // 点击询价列表
    quotelist1() {
      this.flush()
      this.quotelist()
    },
    // 询价列表
    async quotelist() {
      this.spinShow = true
      var pattern = /^\d+$/g
      // console.log(this.enquirysearch)
      this.enquirysearch.odd = this.enquirysearch.odd.replace(/\s*/g, '')
      // console.log(typeof this.enquirysearch.odd)
      if (this.enquirysearch.odd) {
        // console.log('111')
        var result = this.enquirysearch.odd.match(pattern)
        // console.log(result)
        if (result == null) {
          this.$Message.error('请输入正确的单号')
        } else {
          let params = {
            current: this.pager.current,
            size: this.pager.size
          }
          let data = {
            id: this.enquirysearch.odd,
            tenantId: this.tenantId,
            status: this.enquirysearch.state ? this.enquirysearch.state : '-1',
            codeAndName: this.enquirysearch.code,
            offerSid: this.enquirysearch.inquirer
              ? this.enquirysearch.inquirer + ''
              : '-1'
          }
          // console.log('333333')
          const res = await getquotelist(data, params)
          // console.log(res, 'res')
          if (res.status) {
            res.data.records.map((item) => (item.timer = ''))
            this.dataList = res.data.records
            this.pager.total = res.data.total
            for (let i = 0; i <= this.timerinit.length; i++) {
              clearInterval(this.timerinit[i])
            }
            this.timerinit = []
            let b = new Date().getTime()
            this.dataList.forEach((item, index) => {
              item.endTime = parseInt(
                (new Date(item.endTime).getTime() - b) / 1000
              )
              if (item.endTime > 0) {
                this.timerinit[index] = setInterval(() => {
                  this.showTime(item.endTime--, this.timerinit[index], index)
                }, 1000)
              } else {
                clearInterval(this.timerinit[index])
              }
            })
          }
        }
      } else {
        let params = {
          current: this.pager.current,
          size: this.pager.size
        }
        let data = {
          id: this.enquirysearch.odd,
          tenantId: this.tenantId,
          status: this.enquirysearch.state ? this.enquirysearch.state : '-1',
          codeAndName: this.enquirysearch.code,
          offerSid: this.enquirysearch.inquirer
            ? this.enquirysearch.inquirer + ''
            : '-1'
        }
        // console.log('333333')
        const res = await getquotelist(data, params)
        // console.log(res, 'res')
        if (res.status) {
          res.data.records.map((item) => (item.timer = ''))
          this.dataList = res.data.records
          this.pager.total = res.data.total
          for (let i = 0; i <= this.timerinit.length; i++) {
            clearInterval(this.timerinit[i])
          }
          this.timerinit = []
          let b = new Date().getTime()
          this.dataList.forEach((item, index) => {
            item.endTime = parseInt(
              (new Date(item.endTime).getTime() - b) / 1000
            )
            if (item.endTime > 0) {
              this.timerinit[index] = setInterval(() => {
                this.showTime(item.endTime--, this.timerinit[index], index)
              }, 1000)
            } else {
              clearInterval(this.timerinit[index])
            }
          })
        }
        // }
      }
      this.spinShow = false
    },
    // 点击分页(1,2,3)
    changeCurrentbj(current) {
      this.pager.current = current
      this.quotelist()
    },
    // 分页选择
    changeSizebj(size) {
      this.pager.size = size
      this.quotelist()
    },
    // 重新刷新报价数据
    flush() {
      this.pager.current = 1
      this.pager.size = 30
    },
    // 定时器
    showTime(item, interval, index) {
      if (item < 0) {
        if (interval) clearInterval(interval)
      }
      if (this.$route.name != 'askquote') {
        clearInterval(interval)
        return
      }
      let hour =
        parseInt((item % (60 * 60 * 24)) / (60 * 60)) >= 10
          ? parseInt((item % (60 * 60 * 24)) / (60 * 60))
          : '0' + parseInt((item % (60 * 60 * 24)) / (60 * 60))
      let min =
        parseInt((item % (60 * 60)) / 60) >= 10
          ? parseInt((item % (60 * 60)) / 60)
          : '0' + parseInt((item % (60 * 60)) / 60)
      let sec = item % 60 >= 10 ? item % 60 : '0' + (item % 60)
      let text = hour + '小时' + min + '分'
      if (interval && this.dataList.length > 0)
        this.dataList[index].timer = text
      // if (this.$route.name != 'askquote') {
      //   for (let i = 1; i <= interval; i++) {
      //     clearInterval(i)
      //   }
      // }
    },
    // 询价人
    async quotestaff() {
      const res = await getinquireman({
        tenantId: this.tenantId
      })
      if (res.status) {
        this.cityList = res.data
      }
    },
    // 跳转详情
    skipxq(item) {
      this.$router.push({
        path: '/Partsdetails',
        query: {
          partId: item.partId
        }
      })
    },
    // 询价跳转店铺
    xjskip(item) {
      this.$router.push({
        path: '/homePage',
        query: {
          tenantId: item.enquiryTid,
          shopName: item.enquiryTname
        }
      })
    },
    // 报价跳转店铺
    bjskip(item) {
      this.router.push({
        path: '/homePage',
        query: {
          tenantId: item.offerTid,
          shopName: item.offerTname
        }
      })
    },
    // 搜索
    enquiryss() {
      this.quotelist()
    },
    // 报价
    quote(item) {
      // console.log(item)
      // this.button1 = '有货'
      // this.quotedata.noStock = 0
      if (item.noStock === 1){
        this.button1 = '无货'
      }else if (item.noStock === 0){
        this.button1 = '有货'
      }
      this.quotedata = JSON.parse(JSON.stringify(item))
      this.quotetk = true
    },
    // 确认
    async enquiryqd(item) {
      // console.log(item)
      this.$set(item, 'load', true)
      this.pricets = false
      if(this.quotedata.noStock === 0){
        let reg = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/
        if (!reg.test(item.offerPrice)) {
          this.pricets = true
          this.$set(item, 'load', false)
          return
        }
      }
      
      let data = {
        id: this.quotedata.id,
        offerPrice: this.quotedata.noStock === 1 ? 0 : this.quotedata.offerPrice,
        totalMoney: this.quotedata.enquiryNum * this.quotedata.offerPrice,
        storeId: item.storeId,
        remark: this.quotedata.remark,
        noStock: this.quotedata.noStock === 1 ? 1 : 0
      }
      const res = await getquotexx(data)
      this.$set(item, 'load', false)
      if (res.status) {
        this.quotelist()
        this.quotetk = false
      }
    },
    // 取消
    enquiryqx(item) {
      this.pricets = false
      this.quotetk = false
    },
    // 入场动画之前
    beforeEnter(el) {
      el.style.opacity = 0
    },
    // 入场动画过程中
    enter(el, done) {
      let delay = el.dataset.index * 100
      setTimeout(() => {
        el.style.transition = 'opacity 0.4s '
        el.style.opacity = 1
        el.style.animation = 'one-in 0.4s infinite'
        el.style['animation-iteration-count'] = 1
        done()
      }, delay)
    },
    // 展开
    getRelevance(partId, index, item) {
      // console.log(partId)
      // console.log(item)
      this.$set(this.dataList[index], 'isShow', true)
    },
    // 关闭oe
    closeRelevance(index) {
      // console.log(index)
      this.$set(this.dataList[index], 'isShow', false)
    }
  }
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
